import { IsDefined, IsInt, IsNotEmpty, IsOptional, IsString, MaxLength, Min } from 'class-validator';

/**
 * Text API Model
 *
 * This API model defines the data structure for text entities
 * when communicating with the API.
 */
export class TextApiModel {
  /**
   * Numeric identifier for the text
   * Must be greater than 0
   */
  @IsInt()
  @IsDefined()
  @Min(1)
  number!: number;

  /**
   * Name of the text entry
   * Maximum length: 255 characters
   */
  @IsString()
  @IsDefined()
  @MaxLength(255)
  @IsNotEmpty()
  name!: string;

  /**
   * Type of the text entry
   * Maximum length: 50 characters
   */
  @IsString()
  @IsDefined()
  @IsNotEmpty()
  @MaxLength(50)
  type!: string;

  /**
   * Actual text content
   */
  @IsString()
  @IsDefined()
  @IsNotEmpty()
  value!: string;

  /**
   * Formatted (rich text HTML) content of the text entry
   * Optional – populated when the user edits via the rich-text editor
   */
  @IsString()
  @IsOptional()
  formattedValue?: string;
}
